import { RefObject, useEffect } from 'react';

// Inspired by: https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
export function useClickOutside(
  ref: RefObject<HTMLElement>,
  onClickOutside: () => void,
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      // Ignore non-primary buttons so right-clicking (e.g. to paste from the
      // context menu in a portaled drawer) doesn't count as a click outside.
      if (event.button !== 0) {
        return;
      }
      const eventTarget = event.target as HTMLElement;
      if (ref.current && eventTarget && !ref.current.contains(eventTarget)) {
        onClickOutside();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside]);
}
